var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-tab',_vm._b({attrs:{"title":_vm.title}},'van-tab',_vm.$attrs,false),[_c('TaskDetailTabContent',{attrs:{"id":_vm.id,"task-detail":_vm.taskDetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }